<template>
    <FlowCharts />
</template>

<script>
import FlowCharts from './Views/Flow-Charts.vue';

export default {
  components: {
    FlowCharts,
  }
};
</script>

